'use client'
import React, { HTMLAttributes, ReactElement, useEffect } from 'react'
import { LayoutTopPaneType } from './types-and-constants/LayoutPaneTypesAndConstants'
import { useLayoutContext } from '../../../../providers/layout-provider'
import { getRetainBehaviorModifierForPane } from '../helpers/get-retain-behavior-for-pane'
import { Retain } from '../../../atoms/Retain/Retain'
import { RetainBehaviorModifier } from '../../../atoms/Retain/constants/modifiers'

interface Props extends Omit<HTMLAttributes<HTMLDivElement>, 'className'> {
    paneType: LayoutTopPaneType
    children?: ReactElement | ReactElement[]
    customRetainBehaviorModifier?: RetainBehaviorModifier
}

/**
 * @deprecated Prefer LayoutTopPaneRSC
 * */
export const LayoutTopPane = ({ paneType, children, customRetainBehaviorModifier, ...props }: Props): ReactElement => {
    const layoutContext = useLayoutContext()
    const { topPaneState, setTopPaneState } = layoutContext

    if (!paneType && !topPaneState.paneType) {
        console.error('LayoutTopPane must be defined for the Layout to read it.')
    }

    useEffect(() => {
        if (!!paneType) {
            setTopPaneState({ ...topPaneState, paneType })
        }
    }, [paneType])

    const topPaneClasses = [
        'o-layout__top-pane',
        (topPaneState.paneType ?? paneType) === LayoutTopPaneType.TOP_PANE_FIXED && 'o-layout__top-pane--fixed',
        (topPaneState.paneType ?? paneType) === LayoutTopPaneType.TOP_PANE_STICKY && 'o-layout__top-pane--sticky',
    ]
        .filter((i) => !!i)
        .join(' ')

    return (
        <div {...props} className={topPaneClasses}>
            <Retain
                behaviorModifiers={[
                    customRetainBehaviorModifier ?? getRetainBehaviorModifierForPane(paneType, layoutContext),
                ]}
                className="h-full"
                behaviorOnly
            >
                {topPaneState.children ?? children ?? <></>}
            </Retain>
        </div>
    )
}
